const Subscription = () => {

    return (
        <>
            <div className="p-4">
                Subscription Tab is coming soon...
            </div>
        </>
    );
};

export default Subscription;
